import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import SpaceMap from "../../components/view/maps/space-map";
import SpaceForm from "../../components/view/maps/space-form";
import { Grid, Button } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";
import dynamicAPI from '../../api/dynamicAPI';
import { useQuery } from 'react-query';
import { Helmet } from 'react-helmet-async';
import WelcomePopup from "../../components/view/WelcomePopup";
function Maps() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const region = params.get('region') || ''; // Extract the region parameter
    const [showPopup, setShowPopup] = useState(false);
    useEffect(() => {
        const lastSeen = localStorage.getItem('welcomePopupLastSeen');
        const now = Date.now();

        if (!lastSeen || now - parseInt(lastSeen, 10) > 10 * 60 * 1000) {
            setShowPopup(true);
            localStorage.setItem('welcomePopupLastSeen', now.toString());
        }
    }, []);


    const url = '/api/view/spaces';
    const queryKey = ['Spaces', region];
    const { data: spacesData, error: spacesError } = useQuery(
        queryKey,
        async () =>
            await dynamicAPI(
                'get',
                `${url}?page=1&region=${encodeURIComponent(region)}&limit=1000`,
                {}
            ),
        { retry: 0 }
    );

    const navigate = useNavigate();

    // console.log(spacesData);


    return (
        <>
            <Helmet>
                <title>Find Unused Buildings | Communitism Heriscope</title>
                <meta
                    name="description"
                    content="Browse a curated collection of unused buildings"
                    key="desc"
                />
                <meta
                    property="og:title"
                    content="Find Unused Heriscope Buildings "
                    key="ogtitle"
                />
                <meta
                    property="og:description"
                    content="Browse a curated collection of unused buildings"
                    key="ogdesc"
                />
                <meta property="og:url" content="https://heriscope.communitism.space/spaces" />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>

            <WelcomePopup open={showPopup} onClose={() => setShowPopup(false)} />
            <div className='map-block'>
                <ErrorBoundary
                    FallbackComponent={() => (
                        <ErrorFallback goBack={() => navigate(-1)} error={spacesError} />
                    )}
                    onError={console.error}
                >
                    <span className='map-spaces-container'>
                        <Grid gridRow={1} sx={{width: "100%", height: "100%"}}>
                            <Grid sm={12}>
                                <SpaceForm
                                />
                            </Grid>
                            <Grid sm={12}>
                              {spacesData && (
                                  <SpaceMap
                                      generatePins={spacesData.data}
                                      imagesPath={spacesData.images_path}
                                  />
                              )}
                            </Grid>
                        </Grid>
                    </span>
                </ErrorBoundary>
            </div>
        </>
    );
}

function ErrorFallback({ error, goBack }) {
    const errorMessage = error && error.message ? error.message : "Unknown error";

    return (
        <div>
            <div className="user-error-message-block">
                <p>Something went wrong 😭</p>
                <span>Error: {errorMessage}</span>
                <Button onClick={goBack}>Go Back</Button>
            </div>
        </div>
    );
}

export default Maps;